module.exports = __webpack_public_path__ + "static/media/Rubik-Italic.8d8fa3a2.ttf";